import Layout from "../components/common/layouts/Layout";
import { Redirect, Route, Switch } from "react-router-dom";
import loadable from "@loadable/component";
import PrivateRoute from "../components/common/auth/PrivateRoute";
import { Skeleton } from "@chakra-ui/react";
import ApplicationRoutes from "./ApplicationRoutes";

import { HeaderContext, HeaderReducer, initState } from "../components/common/layouts/HeaderState";
import { useReducer } from "react";

function Loading() {
  return (
    <>
      <Skeleton h="15rem" m="2rem" isLoaded={false} />
      <Skeleton h="15rem" m="2rem" isLoaded={false} />
      <Skeleton h="15rem" m="2rem" isLoaded={false} />
    </>
  );
}

// Lazy loaded routes
const KitchenSink = loadable(() => import("../pages/kitchen-sink/KitchenSink"), {
  fallback: <Loading />,
});

const GridsExample = loadable(() => import("../pages/kitchen-sink/GridsExample"), {
  fallback: <Loading />,
});

const Courses = loadable(() => import("../pages/Courses/"), {
  fallback: <Loading />,
});

const Profile = loadable(() => import("../pages/Profile/"), {
  fallback: <Loading />,
});

const ProfileApplications = loadable(() => import("../pages/Profile/ProfileApplications"), {
  fallback: <Loading />,
});

const Referrals = loadable(() => import("../pages/Profile/referrals"), {
  fallback: <Loading />,
});

const CourseDetails = loadable(() => import("../pages/CourseDetails"), {
  fallback: <Loading />,
});

const Events = loadable(() => import("../pages/Events/Events"), {
  fallback: <Loading />,
});

const Contests = loadable(() => import("../pages/Contests"), {
  fallback: <Loading />,
});
const BatchDocs = loadable(() => import("../pages/Application/msat/BatchDocs"), {
  fallback: <Loading />,
});
const MSATSyllabus = loadable(() => import("../pages/Application/msat/new-msat/MSATSyllabus"), {
  fallback: <Loading />,
});

const SelfLearning = loadable(() => import("../pages/SelfLearning"), {
  fallback: <Loading />,
});

const AddReferral = loadable(() => import("../pages/Profile/referrals/add/AddReferral"), {
  fallback: <Loading />,
});

const ProfileEdit = loadable(() => import("../pages/Profile/ProfileEdit"), {
  fallback: <Loading />,
});

const MSATSuccess = loadable(() => import("../pages/Application/msat/MSATSuccess"), {
  fallback: <Loading />,
});

const OnboardingPending = loadable(
  () => import("../pages/Application/onboarding/OnboardingPending"),
  {
    fallback: <Loading />,
  }
);

const BookEvent = loadable(() => import("../components/events/book-event/BookEvent"), {
  fallback: <Loading />,
});
const ContestDetails = loadable(() => import("../components/events/book-event/ContestDetails"), {
  fallback: <Loading />,
});

const SignIn = loadable(() => import("../components/common/auth/TempSignin"), {
  fallback: <Loading />,
});

type RouteProps = {
  path: string;
  name: string;
  isPrivate: boolean;
  component: JSX.Element;
  hidden: boolean;
  useLayout: boolean;
  exact?: boolean;
};

const routes: RouteProps[] = [
  {
    path: "/",
    name: "Home",
    exact: true,
    isPrivate: true,
    component: <Courses />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/batch-docs",
    name: "Batch Docs",
    exact: true,
    isPrivate: true,
    component: <BatchDocs />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/msat-syllabus",
    name: "MSAT Syllabus",
    exact: true,
    isPrivate: true,
    component: <MSATSyllabus heading={"MSAT Syllabus"} />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/scholarship-test-syllabus",
    name: "Scholarship Test Syllabus",
    exact: true,
    isPrivate: true,
    component: <MSATSyllabus heading={"Scholarship Test Syllabus"} isScholarhipTest={true} />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/courses",
    name: "Courses",
    exact: true,
    isPrivate: true,
    component: <Courses />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/events",
    name: "Events",
    exact: true,
    isPrivate: true,
    component: <Events />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/events/:eventID/book",
    name: "Book Event",
    exact: true,
    isPrivate: true,
    component: <BookEvent />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/contests/:contestID/details",
    name: "Contest Details",
    exact: true,
    isPrivate: true,
    component: <ContestDetails />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/self-learning",
    name: "Self Learning",
    exact: true,
    isPrivate: true,
    component: <SelfLearning />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/referral-program",
    name: "Referral Program",
    exact: true,
    isPrivate: true,
    component: <AddReferral />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/isa",
    name: "ISA",
    exact: true,
    isPrivate: true,
    component: <></>,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/faqs",
    name: "FAQs",
    exact: true,
    isPrivate: true,
    component: <></>,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/courses/:batchID/details",
    name: "Course Details",
    exact: true,
    isPrivate: true,
    component: <CourseDetails />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/profile",
    name: "Profile",
    exact: true,
    isPrivate: true,
    component: <Profile />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/profile/edit",
    name: "Profile Edit",
    exact: true,
    isPrivate: true,
    component: <ProfileEdit />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/profile/referrals",
    name: "Applicant Onboarding",
    exact: true,
    isPrivate: true,
    component: <Referrals />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/profile/referrals/add",
    name: "Applicant Onboarding",
    exact: true,
    isPrivate: true,
    component: <AddReferral />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/profile/applications",
    name: "Profile Applications",
    exact: true,
    isPrivate: true,
    component: <ProfileApplications />,
    hidden: false,
    useLayout: true,
  },
  {
    path: "/batch/:batchID/:applicantID/msat-success",
    name: "Applicant cleared MSAT and Communication Evaluation",
    exact: true,
    isPrivate: true,
    component: <MSATSuccess />,
    hidden: false,
    useLayout: true,
  },

  {
    path: "/kitchen-sink",
    name: "Kitchen Sink",
    exact: true,
    isPrivate: true,
    component: <KitchenSink />,
    hidden: process.env.NODE_ENV === "production",
    useLayout: true,
  },
  {
    path: "/test",
    name: "Onboarding Page Demo",
    exact: true,
    isPrivate: false,
    component: <OnboardingPending />,
    hidden: false,
    useLayout: true,
  },

  {
    path: "/kitchen-sink/grids",
    name: "Kitchen Sink",
    exact: true,
    isPrivate: true,
    component: <GridsExample />,
    //FIXME: don't do this. just push in the array if (env===dev). no need to support a new flag for 1 component
    // This is a default flag provided by sytem
    hidden: process.env.NODE_ENV === "production",
    useLayout: true,
  },
];

// TODO: Create application specific routes that will maintain a context
// ? Maybe spearate out those routes and manage it from there
// ? Create context to manage data
// ? Check route
// FIXME: Layout shouldn't be inside route, navbar, sidebar doesn't need to reload on every single route change

const Routes: React.FC = () => {
  const [state, dispatch] = useReducer(HeaderReducer, initState);
  return (
    <>
      <HeaderContext.Provider value={[state, dispatch]}>
        <Switch>
          {routes.map((route) =>
            route.isPrivate ? (
              <PrivateRoute key={route.path} exact={route.exact} path={route.path}>
                {route.useLayout ? <Layout>{route.component}</Layout> : <>{route.component}</>}
              </PrivateRoute>
            ) : (
              // <Route key={route.path} {...route}>
              <Route key={route.path} path={route.path}>
                <Layout>{route.component}</Layout>
              </Route>
            )
          )}
          <ApplicationRoutes />
          <Route>
            <Redirect to="/" />
          </Route>
        </Switch>
      </HeaderContext.Provider>
    </>
  );
};

export default Routes;
